import React, { useEffect } from 'react';
import { Result } from 'antd';
export default function Error404() {


    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [])
    return<>
    <div className='h-screen flex justify-center items-center'>
    <Result
    status="404"
    // title="404"
    // subTitle="Sorry, the page you look for doesn't exist."
    />
    </div>
    </>
}
